module.exports = {
      id: "technology-usage",
      viewBox: "0 0 22.958 22.633",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#technology",
      toString: function () {
        return this.url;
      }
    }